var _line, _line2, _line3, _line4, _line5, _line6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCenterAlign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.75,
    y1: 1.25,
    x2: 19.25,
    y2: 1.25,
    stroke: "#2C2C2C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 2.75,
    y1: 5.25,
    x2: 17.25,
    y2: 5.25,
    stroke: "#2C2C2C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 0.75,
    y1: 9.25,
    x2: 19.25,
    y2: 9.25,
    stroke: "#2C2C2C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 2.75,
    y1: 13.25,
    x2: 17.25,
    y2: 13.25,
    stroke: "#2C2C2C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 6.25,
    y1: 17.25,
    x2: 13.75,
    y2: 17.25,
    stroke: "#2C2C2C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 0.75,
    y1: 21.25,
    x2: 19.25,
    y2: 21.25,
    stroke: "#2C2C2C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenterAlign);
export default __webpack_public_path__ + "static/media/center-align.dd713c1e5793e90ab164e87abd3e33c3.svg";
export { ForwardRef as ReactComponent };